import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import theme from "../../theme";
import { Link, useParams } from "react-router-dom";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import useButtonStyles from "../../styles/useButtonStyles";
import axios from "axios";
import { APIConstants, APIModuleConstants } from "../../constants/ApiConstants";
import { useAppSelector } from "../../redux/hooks";
import { formatDateReport, getEncodedValue } from "../forms/utility";
import formatDate, {
  dateFormat,
  getFormattedDate,
} from "../../util/dateFormat";
import AddVoucherToReport from "./AddVoucherToReport";
import { constant } from "../../constants";
import BasicModal from "../ui/BasicModal";
import DownloadForOfflineRoundedIcon from "@mui/icons-material/DownloadForOfflineRounded";
import InfiniteTable from "../Table/InfiniteScroll/InfiniteTable";
import { getHashURL } from "../../util/SearchandFIlters/searchAndFilter";
import formatDateAndTime from "../../util/scanDate";
import useGetTotalRecords from "../../Hooks/CustomHooks/UseGetTotalRecords";
import {
  SearchToolTip,
  filterConstants,
  hashKey,
  modelName,
  permissionsConstants,
} from "../../constants/AppConstants";
import SearchInput from "../../Shared/Components/SearchInput/SearchInput";
import ExportDialog from "../../Shared/Components/ExportDialog/ExportDialog";
import { exportData } from "../../services/ApiServices/export";
import { usePermissionGetter } from "../../Hooks/Permissions/userPermissionGetter";
import { CommonButton } from "../../Shared/Components/Buttons/CommonButton";
interface TableColumn {
  key: string;
  header: string;
  searchable?: boolean;
  filterable?: boolean;
  isCheckbox?: boolean;
}
interface PVoucherData {
  id: string;
  expiry_date: string;
  scan_time_stamp: string;
  amount: string;
  scanner_id: string;
  reason: string;
}

const ViewPVReportDetails = () => {
  const { getUserPermission: getPhysicalPermission } = usePermissionGetter(
    "finance",
    "reimbursment_physical_voucher"
  );
  const { getUserPermission: getMerchantPhysicalPermission } =
    usePermissionGetter(
      permissionsConstants.physical_voucher_reimbursement,
      permissionsConstants.physical_voucher_reimbursement
    );

  const buttonStyles = useButtonStyles();
  const [loading, setLoading] = useState(false);
  const [DetailsData, setDetailsData] = useState([]);
  const [openExport, setOpenExport] = useState(false);
  const [emailSent, setEmailSent] = useState(false);
  const [exportEmail, setExportEmail] = useState("");
  const [sending, setSending] = useState(false);
  const [visited, setVisited] = useState(false);
  const [validEmail, setValidEmail] = useState(false);
  const [selectedItems, setSelectedItems] = useState<PVoucherData[]>([]);
  const [open, setOpen] = useState(false);
  const [showModal, setShowModal] = useState<boolean>(false);
  const [error, setError] = useState(false);
  const [loadingAPI, setLoadingAPI] = useState<boolean>(false);
  const [showDelete, setShowDelete] = useState<boolean>(false);
  const [isApiCall, setIsApiCall] = useState(true);
  const [deletionReason, setDeletionReason] = useState("");
  const [lastKey, setLastKey] = useState(null);
  const params = useParams();
  const { PVoucherId } = params;
  const currentDate = formatDateReport(new Date().toISOString());
  const REPORTID = window.location.pathname.split("/").pop();
  const physicalVoucherList = useAppSelector(
    (state: any) => state.persistReducers.financeSlice?.physicalVoucher
  );
  const { totalCount, getTotalRecordsCount } = useGetTotalRecords();

  const filterHeader = physicalVoucherList.filter(
    (item: any) => item.reportIdDetail === PVoucherId
  );
  const headerDetails = filterHeader[0];
  const reportStatus = headerDetails?.status;

  const columnsAdmin: TableColumn[] = [
    { key: "selectAll", header: "Select", isCheckbox: true },
    { key: "voucher_number", header: "Voucher Number" },
    { key: "amount", header: "Voucher Amount" },
    { key: "utilizedDate", header: "Utilized Date" },
    { key: "expiry_date", header: "Expiry Date" },
    { key: "status", header: "Verified" },
  ];
  const columnsMerchant: TableColumn[] = [
    { key: "voucher_number", header: "Voucher Number" },
    { key: "amount", header: "Voucher Amount" },
    { key: "utilizedDate", header: "Utilized Date" },
    { key: "expiry_date", header: "Expiry Date" },
  ];

  const getPhysicalVouchers = async (
    url: string,
    canHaveExistingData?: boolean
  ) => {
    try {
      setLoading(true);
      if (lastKey)
        url += `&lastKey=${encodeURIComponent(JSON.stringify(lastKey))}`;
      const voucherResponse = await axios.get(url);
      const { lastKey: apiKey, value: result } =
        voucherResponse?.data?.data?.data;
      setLastKey(apiKey || null);
      const mapped = result.map((voucher: any) => {
        return {
          ...voucher,

          amount: `S$ ${voucher.amount}`,
          utilizedDate: voucher.scan_time_stamp
            ? getFormattedDate(voucher.scan_time_stamp, dateFormat.DMMMMYYYY)
            : "-",
          scan_time_stamp: voucher.scan_time_stamp
            ? formatDate(voucher.scan_time_stamp)
            : "-",
          merchant_approval:
            voucher.merchant_approval === true
              ? filterConstants.Yes
              : filterConstants.No,
          expiry_date: voucher.expiry_date
            ? formatDate(voucher.expiry_date, true)
            : "-",
          createdAt: voucher.createdAt ? formatDate(voucher.createdAt) : "-",
          updatedAt: voucher.updatedAt ? voucher.updatedAt : "-",
          status:
            voucher.status === "submitted"
              ? filterConstants.Pending.toLowerCase()
              : "-",
        };
      });
      const dataToSet = canHaveExistingData
        ? [...DetailsData, ...mapped]
        : mapped;
      setDetailsData(dataToSet);
    } catch (error) {
      console.error(error);
      setLoading(false);
      setIsApiCall(false);
    } finally {
      setLoading(false);
      setIsApiCall(false);
    }
  };

  const handleExport = () => {
    setOpen(true);
  };
  const handleExportClose = () => {
    setOpen(false);
  };

  const HandleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setExportEmail(e.target.value);
    isValidEmail(e.target.value);
  };

  const headerMapping: Record<string, string> = {
    voucher_number: "Voucher Number",
    scan_time_stamp: "Scan time",
    scanner_id: "Scan ID",
    merchant_name: "Merchant Name",
    createdAt: "Created At",
    modifiedBy: "Modified By",
    expiry_date: "Expiry Date",
    amount: "Voucher Amount",
    merchant_id: "Merchant ID",
    status: "Verified",
    bi_status: "BI Status",
    receivedDate: "Received Date",
    utilizedDate: "Utilized Date",
    createdBy: "Created By",
    admin_email: "Admin Email",
    report_id: "Report ID",
    validity: "Validity",
    updatedAt: "Updated At",
    modified_by: "Modified By",
    reason: "Reason",
    merchant_approval: "Merchant Approval",
    scan_transaction_id: "Scan Txn ID",
    id: "ID",
    issue_date: "Issue Date",
  };

  const formatCSVData = (data: any[]) => {
    const order = [
      "Voucher Number",
      "Voucher Amount",
      "Utilized Date",
      "Expiry Date",
      "Verified",
    ];
    function sortByOrder(object: any, order: any) {
      const sortedObject: any = {};
      order?.forEach((key: any) => {
        if (object?.hasOwnProperty(key)) {
          sortedObject[key] = object[key];
        }
      });
      return sortedObject;
    }
    return data?.map((csvRow) => {
      const renamedRow = {
        ...csvRow,
        Type: "Physical Voucher",
      };
      const excludedColumns = [
        "id",
        "scan_transaction_id",
        "scanner_id",
        "reason",
        "report_id",
        "issue_date",
        "merchant_approval",
        "merchant_name",
        "scan_time_stamp",
        "createdAt",
        "updatedAt",
        "merchant_id",
        "bi_status",
        "validity",
        "admin_email",
      ];

      for (const key in renamedRow) {
        if (excludedColumns.includes(key)) {
          delete renamedRow[key];
        } else {
          if (headerMapping[key]) {
            renamedRow[headerMapping[key]] = renamedRow[key];
            delete renamedRow[key];
          }
        }
      }

      if (renamedRow.navigateTo) {
        delete renamedRow.navigateTo;
      }

      return sortByOrder(renamedRow, order);
    });
  };

  useEffect(() => {
    if (selectedItems.length !== 0) {
      setShowDelete(true);
    } else {
      setShowDelete(false);
    }
  }, [selectedItems]);

  const handleCheckboxChange = (item: PVoucherData, checked: boolean) => {
    if (checked) {
      setSelectedItems((prevSelectedItems) => [...prevSelectedItems, item]);
    } else {
      setSelectedItems((prevSelectedItems) =>
        prevSelectedItems.filter((selectedItem) => selectedItem !== item)
      );
    }
  };

  const handleDelete = async () => {
    if (!deletionReason.trim()) {
      return;
    }
    const payload = selectedItems.map((item: any) => ({
      id: item.id,
      scanner_id: item.scanner_id,
      status: "Deleted",
      reason: deletionReason,
    }));

    try {
      setLoadingAPI(true);
      const axiosResponse = await axios.patch(
        process.env.REACT_APP_API_URL + APIConstants.deleteVoucher,
        payload
      );
      setShowModal(true);
      setLoadingAPI(false);
      setIsApiCall(true);
    } catch (error) {
      setShowModal(true);
      setError(true);
      console.error(error);
      setLoadingAPI(false);
    } finally {
      setTimeout(() => window.location.reload(), 3000);
      setLoadingAPI(false);
    }
  };

  const handleSendExport = async () => {
    const getFilterURL = getParams();
    setSending(true);
    const handleExportFun = await exportData(
      getFilterURL,
      modelName.physicalVoucherDetails,
      hashKey.reportId,
      `${REPORTID}`
    );
    handleExportFun.data.status && setEmailSent(true);
    setSending(false);
    setTimeout(() => {
      setEmailSent(false);
    }, 3000);
  };

  const isValidEmail = (email: any) => {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (emailRegex.test(email)) {
      setValidEmail(true);
    } else {
      setValidEmail(false);
    }
  };

  const handleLocalDownload = () => {
    const exportableData = formatCSVData(DetailsData);

    if (exportableData.length > 0) {
      const fields = Object.keys(exportableData[0]);
      const csvRows = [fields.join(",")];

      for (const row of exportableData) {
        const values = fields.map((field) => JSON.stringify(row[field]));
        csvRows.push(values.join(","));
      }

      const csvContent = `Physical Voucher Report ID : ${REPORTID}\nExport Date: ${currentDate}\n${csvRows.join(
        "\n"
      )}\n`;
      const blob = new Blob([csvContent], { type: "text/csv" });
      const url = URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.href = url;
      a.download = "physical-voucher-report.csv";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    } else {
      console.error("No data to export");
    }
  };
  // search
  const handleSearchByVoucherNumber = (voucherNumberToSearch: any) => {};
  const handleAddVoucherToReport = (selectedVoucherNumber: any) => {};

  useEffect(() => {
    if (isApiCall) bindSearchAndFilter();
  }, [isApiCall]);
  const searchInputRef = useRef<HTMLInputElement>();
  const handleSearch = () => {
    setDetailsData([]);
    setLastKey(null);
    setIsApiCall(true);
  };

  const bindSearchAndFilter = (canMergeData?: boolean) => {
    const url = getParams();
    let querParams = `reportId=${PVoucherId}&${url}`;
    const newURL = `${
      process.env.REACT_APP_API_URL + APIConstants.getPhysicalVoucherList
    }?${querParams}`;
    if (!DetailsData?.length)
      getTotalRecordsCount(APIModuleConstants.pvoucherReport, querParams);
    getPhysicalVouchers(newURL, canMergeData);
  };
  const getParams = () => {
    const hashValues = { field: "placeholderId", value: "ALL-RECORDS" };
    const value = searchInputRef.current
      ? getEncodedValue(searchInputRef.current?.value)
      : "";
    const searchParam = value !== "" ? [value] : [];
    const params = {
      hashData: hashValues,
      searchData: searchParam,
    };
    const url = getHashURL(params);
    return url;
  };

  const isHavingPermission = (key: string) => {
    return getMerchantPhysicalPermission(key) || getPhysicalPermission(key);
  };

  return (
    <Grid
      sx={{ background: theme.color?.background }}
      borderRadius={"16px"}
      overflow={"hidden"}
    >
      <ExportDialog
        closeDialog={setOpen}
        emailSent={emailSent}
        exportTitle="Physical Voucher Reports"
        handleClose={handleExportClose}
        open={open}
        sending={sending}
        handleSendExport={handleSendExport}
      />
      <Grid
        height={"6rem"}
        p={3}
        px={5}
        alignItems={"center"}
        sx={{ backgroundColor: theme.color?.background }}
        display={"flex"}
        justifyContent={"space-between"}
        borderBottom={theme.border?.newGreyBorder}
      >
        <Grid display={"flex"} gap={1}>
          <Grid
            item
            sx={{ cursor: theme?.cursor?.pointer }}
            display={"flex"}
            alignItems={"center"}
          >
            {window.location.pathname.includes("/merchant") ? (
              <Link to="/physicalVoucher">
                <ArrowBackIosIcon
                  sx={{ color: theme.color?.primary, textDecoration: "none" }}
                />
              </Link>
            ) : (
              <Link to="/finance?tab=reimbursementPhysicalVoucher">
                <ArrowBackIosIcon
                  sx={{ color: theme.color?.primary, textDecoration: "none" }}
                />
              </Link>
            )}
          </Grid>
          <Typography
            variant="h6"
            sx={{
              fontFamily: theme.font?.fontFamily.primary,
              fontWeight: 600,
              color: theme.color?.primary,
            }}
          >
            Report Details
          </Typography>
        </Grid>
        <Grid display={"flex"} gap={2} alignItems={"center"}>
          {isHavingPermission("export") && (
            <CommonButton
              buttonTitle="Export"
              variant="text"
              color="secondary"
              disabled={!DetailsData.length}
              onClick={handleExport}
            />
          )}
          {isHavingPermission("download") && (
            <CommonButton
              buttonTitle="Download"
              variant="text"
              color="secondary"
              disabled={!DetailsData.length}
              onClick={handleLocalDownload}
              endIcon={<DownloadForOfflineRoundedIcon />}
            />
          )}
          <SearchInput
            HelpTip={SearchToolTip.VoucherDetails}
            onCallBack={handleSearch}
            ref={searchInputRef}
          />
        </Grid>
      </Grid>
      <Grid p={2} pl={4} pr={4}>
        <Grid
          sx={{ backgroundColor: theme.color?.background }}
          borderRadius={4}
          p={3}
          pl={4}
          mt={3}
          border={theme.border?.newGreyBorder}
          display={"flex"}
        >
          <Grid width={"60%"}>
            <Grid display={"flex"} gap={2} pl={3}>
              <Typography
                width={"30%"}
                sx={{
                  fontFamily: theme.font?.fontFamily.primary,
                  color: theme.color?.tableGrey,
                  // textAlign: "end",
                }}
              >
                Merchant Name:
              </Typography>
              <Typography
                width={"70%"}
                sx={{
                  fontFamily: theme.font?.fontFamily.primary,
                  color: theme.color?.dark,
                }}
              >
                {headerDetails && headerDetails.merchant}
              </Typography>
            </Grid>
            <Grid display={"flex"} gap={2} pl={3}>
              <Typography
                width={"30%"}
                sx={{
                  fontFamily: theme.font?.fontFamily.primary,
                  color: theme.color?.tableGrey,
                  // textAlign: "end",
                }}
              >
                Report ID:
              </Typography>
              <Typography
                width={"70%"}
                sx={{
                  fontFamily: theme.font?.fontFamily.primary,
                  color: theme.color?.dark,
                }}
              >
                {headerDetails && headerDetails.reportId}
              </Typography>
            </Grid>
            <Grid display={"flex"} gap={2} pl={3}>
              <Typography
                width={"30%"}
                sx={{
                  fontFamily: theme.font?.fontFamily.primary,
                  color: theme.color?.tableGrey,
                  // textAlign: "end",
                }}
              >
                Submitted:
              </Typography>
              <Typography
                width={"70%"}
                sx={{
                  fontFamily: theme.font?.fontFamily.primary,
                  color: theme.color?.dark,
                }}
              >
                {headerDetails?.submissionDate
                  ? headerDetails.submissionDate
                  : "-"}
              </Typography>
            </Grid>
            <Grid display={"flex"} gap={2} pl={3}>
              <Typography
                width={"30%"}
                sx={{
                  fontFamily: theme.font?.fontFamily.primary,
                  color: theme.color?.tableGrey,
                  // textAlign: "end",
                }}
              >
                Report type:
              </Typography>
              <Typography
                width={"70%"}
                sx={{
                  fontFamily: theme.font?.fontFamily.primary,
                  color: theme.color?.dark,
                }}
              >
                {headerDetails && headerDetails.voucherType}
              </Typography>
            </Grid>
          </Grid>
          {showDelete && (
            <Grid
              px={5}
              py={2}
              display={"flex"}
              flexDirection={"column"}
              gap={2}
              alignItems={"end"}
              width={"40%"}
              justifyContent={"end"}
            >
              <Grid>
                <Typography
                  sx={{
                    fontFamily: theme.font?.fontFamily.primary,
                    fontSize: theme.font?.fontSize.tableHeader,
                    fontWeight: theme.font?.fontWeight.slightThick,
                  }}
                >
                  Deleting reason*
                </Typography>
                <Grid display={"flex"} alignItems={"center"} gap={1}>
                  <TextField
                    size="small"
                    value={deletionReason}
                    onChange={(e) => setDeletionReason(e.target.value)}
                  />
                  <Button
                    sx={buttonStyles.containedDanger}
                    variant="contained"
                    onClick={handleDelete}
                    disabled={!deletionReason.trim()}
                  >
                    {loadingAPI ? (
                      <CircularProgress size={24} color="primary" />
                    ) : (
                      "Delete"
                    )}
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          )}
        </Grid>
      </Grid>

      {isHavingPermission("update") &&
        reportStatus === filterConstants.Pending && (
          <AddVoucherToReport
            voucherNumbers={[""]}
            onSearch={handleSearchByVoucherNumber}
            onAdd={handleAddVoucherToReport}
          />
        )}
      <Grid container width={"100%"} px={3} mt={3}>
        <InfiniteTable
          header={
            isHavingPermission("update") &&
            reportStatus === filterConstants.Pending
              ? columnsAdmin
              : columnsMerchant
          }
          contentItems={DetailsData}
          onInputChange={handleCheckboxChange}
          fetchMoreData={() => bindSearchAndFilter(true)}
          hasMoreRecords={lastKey !== null}
          isInitialLoading={DetailsData.length === 0 && loading}
          totalRecords={totalCount}
        />
      </Grid>
      {showModal &&
        (error ? (
          <BasicModal
            title={"Error While Deleting"}
            success={false}
            setState={setShowModal}
          />
        ) : (
          <BasicModal
            title={"Delete Successful!"}
            success={true}
            setState={setShowModal}
          />
        ))}
    </Grid>
  );
};

export default ViewPVReportDetails;
